import React from 'react';

import AdminStatsView from 'views/Admin/AdminStatsView';

const AdminDashboardPage = () => (
  <AdminStatsView />
);

export default AdminDashboardPage;
